import React from 'react';
import _ from 'lodash';
import {
  Paper,
  GridListTile,
  GridList,
  ListSubheader
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { getSessionByKey, getEncodedQueryParams } from 'helpers';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { TE } from 'appconstants';

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper
  },
  grdItem: {
    margin: 5,
    // height: 100,
    // width: 150,
    float: 'center',
    borderRadius: '8px',
    cursor: 'pointer',
    backgroundColor: theme.palette.primary.light
  },
  gridList: {
    // width: 600
    flex: 1
  },
  text: {
    color: 'white'
  },
  control: {
    padding: theme.spacing(2)
  }
});

const withConnectState = connect((state, ownProps) => ({
  userPrefProtocol: state.common.userPrefProtocol
}));


const ProtocolHomeContent = ({ classes, dispatch }) => {
  const userPref = getSessionByKey('user_recent_protocols');
  const recentProt = userPref && JSON.parse(userPref);
  return (
    <div className={`${classes.root} card-wrapper MuiPaper-elevation1`} style={{ paddingTop: '1rem', paddingBottom: '1rem' }}>
      <GridList
        cellHeight={160}
        cols={4}
        className={classes.gridList}
      >
        <GridListTile key="Subheader" cols={4} style={{ height: 'auto' }}>
          <ListSubheader data-id={`${TE.ID}protocol_home_${TE.DIV}`} component="div">Recently Viewed Protocol(s)</ListSubheader>
        </GridListTile>
        {recentProt ? _.reverse(recentProt).map(value => (
          <GridListTile
            cols={0}
            key={_.uniqueId('protocol_visited')}
            style={{ height: 'auto' }}
          >
            <Link
              to={getEncodedQueryParams('protocol/', `${value}/protocoldetail`)}
              className="protocol-graphic-tiles"
              data-id={`${TE.ID}protocol_home_${value}${TE.LINK}`}
            >
              <Paper className={classes.grdItem}>
                <div data-id={`${TE.ID}protocol_home_card_${TE.DIV}`} className={classes.text}>{value}</div>
              </Paper>
            </Link>
          </GridListTile>
        )) : <div data-id={`${TE.ID}no_recently_viewed_${TE.DIV}`}>No Recently Viewed Protocol(s) found</div>}
      </GridList>
    </div>
  );
};

export default withStyles(styles)(
  compose(
    withConnectState
  )(ProtocolHomeContent)
);
